import { BehaviorSubject } from 'rxjs';
import CasClient, { constant } from "./index.js";
import Cookies from 'universal-cookie';

const APIURL = process.env.REACT_APP_API_URL;

const cookies = new Cookies();

const currentUser = {
    usuario: "",
    numeroidentificacion: "",
    roles: []
};

const currentUserSubject = new BehaviorSubject(currentUser);
const [CAS_PROTOCOL, CAS_SERVER] = (process.env.REACT_APP_CAS_URL).split("://");
const [PROXY_PROTOCOL, PROXY_SERVER] = APIURL.split("://");

const casOptions = {
    version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PROTOCOL, validation_proxy: true, validation_proxy_protocol: PROXY_PROTOCOL,
    validation_proxy_endpoint: PROXY_SERVER, validation_proxy_path: "/api/Account/"
}

const casClient = new CasClient(CAS_SERVER, casOptions);

export const authService = {
    login,
    logout,
    validateToken,
    setGlobalFetch,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value },
};

function login(history, gateway = false) {
    casLogin(history, gateway);
}

function logout() {
    signout();
    casLogout();
}

function casLogin(history, gateway = false) {
    //console.log("AdminLayout casLogin gateway = " + (gateway ? "true" : "false"));
    casClient
        .auth(gateway)
        .then(successRes => {
            //console.log("App successRes = " + JSON.stringify(successRes));
            history.replace(successRes.currentPath);
            signin(successRes.user)
        })
        .catch(errorRes => {
            //console.log("App errorRes = " + JSON.stringify(errorRes));
            history.replace(errorRes.currentPath);
        });
}

function casLogout() {
    casClient.logout();
}

function signin(data) {

    if (data) {
        let signinUser = {
            usuario: data.netId,
            numeroidentificacion: data.numeroidentificacion,
            tipoidentificacion: data.tipoidentificacion,
            apellidos: data.apellidos,
            nombres: data.nombres,
            roles: data.roles,
            token: data.token,
            isImpersonated: false
        };

        let realFetch = window.fetch;
        window.fetch = function (url, opts = null) {
            if (opts == null) opts = {};
            let headers = opts != null && opts.headers != undefined ? opts.headers : {};

            if (signinUser.token) {
                headers = Object.assign({}, headers, { 'Authorization': `Bearer ${signinUser.token}` });

                if (url.indexOf('FileUpload') < 0 && headers['Content-Type'] == undefined) {
                    headers = Object.assign({}, headers, { 'Content-Type': 'application/json' });
                }
                opts.headers = headers;
                return realFetch(url, opts);

            } else {
                return realFetch(url, opts);
            }
        };

        cookies.set('authToken', signinUser.token, {
            path: '/'
        });
        cookies.remove('impersonateToken', { path: '/' });
        currentUserSubject.next(signinUser);
    }

}

function validateToken(token, decodedToken, isImpersonating = false) {
    let signinUser = {
        usuario: decodedToken.username,
        numeroidentificacion: decodedToken.identificacion,
        tipoidentificacion: decodedToken.tipoidentificacion,
        apellidos: decodedToken.apellidos,
        nombres: decodedToken.nombres,
        roles: decodedToken.rolesObj
            ? Array.isArray(decodedToken.rolesObj)
                ? decodedToken.rolesObj.map(roleObj => {
                    const role = JSON.parse(roleObj);
                    return {
                        role: role.Role,
                        scope: role.Scope,
                        scopeName: role.ScopeName
                    };
                })
                : [JSON.parse(decodedToken.rolesObj)].map(roleObj => {
                    return {
                        role: roleObj.Role,
                        scope: roleObj.Scope,
                        scopeName: roleObj.ScopeName
                    };
                })
            : [],
        token: token,
        isImpersonated: isImpersonating
    };
    currentUserSubject.next(signinUser);

    setGlobalFetch();
}

function signout() {
    cookies.remove('authToken', { path: '/' });
    cookies.remove('impersonateToken', { path: '/' });
    currentUserSubject.next(null);
}

function setGlobalFetch() {
    let realFetch = window.fetch;
    window.fetch = function (url, opts = null) {
        if (opts == null) opts = {};
        let headers = opts != null && opts.headers != undefined ? opts.headers : {};

        const token = cookies.get('impersonateToken') || cookies.get('authToken');

        if (token) {
            headers = Object.assign({}, headers, { 'Authorization': `Bearer ${token}` });

            if (url.indexOf('FileUpload') < 0 && headers['Content-Type'] == undefined) {
                headers = Object.assign({}, headers, { 'Content-Type': 'application/json' });
            }
            opts.headers = headers;
            return realFetch(url, opts);
        } else {
            return realFetch(url, opts);
        }
    };
}